// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  matchId: __t.string().primaryKey().name("match_id"),
  stateVersion: __t.u64().name("state_version"),
  eventsJson: __t.string().name("events_json"),
  tickEventsJson: __t.string().name("tick_events_json"),
  capturePointsJson: __t.option(__t.string()).name("capture_points_json"),
  structureHpJson: __t.option(__t.string()).name("structure_hp_json"),
  gateOpenJson: __t.option(__t.string()).name("gate_open_json"),
  campsJson: __t.option(__t.string()).name("camps_json"),
  wallBuildProjectsJson: __t.option(__t.string()).name("wall_build_projects_json"),
  roadsJson: __t.option(__t.string()).name("roads_json"),
  runtimeStructuresJson: __t.option(__t.string()).name("runtime_structures_json"),
  woodStockpileJson: __t.option(__t.string()).name("wood_stockpile_json"),
  harvestTilesJson: __t.option(__t.string()).name("harvest_tiles_json"),
  antGroupsJson: __t.option(__t.string()).name("ant_groups_json"),
  terrainOverridesJson: __t.option(__t.string()).name("terrain_overrides_json"),
  watchtowersJson: __t.option(__t.string()).name("watchtowers_json"),
  pendingCommandEventsJson: __t.option(__t.string()).name("pending_command_events_json"),
  columnFormationsJson: __t.option(__t.string()).name("column_formations_json"),
  formationCatalogJson: __t.option(__t.string()).name("formation_catalog_json"),
});
